import { useEffect } from 'react';

export const useAutomaticRefresh = () => {
  useEffect(() => {
    const timeoutId = setTimeout(() => window.location.reload(), 1000 * 60 * 60);

    return () => clearTimeout(timeoutId);
  }, []);
};
